import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import DateTime from '../../../../components/Forms/DateTime';
import { WEEK, MONTH } from '../../utils';

const InputDate = ({ viewBy, startDate, setStartDate }) => {
  const DISABLED = viewBy === null;

  const setDate = date => {
    setStartDate(date);
  };

  useEffect(() => {
    setStartDate(startDate);
  }, [startDate]);

  return (
    <>
      {viewBy === WEEK && (
        <DateTime
          disabled={viewBy === null}
          label="Week selected"
          selected={startDate}
          onChange={setDate}
        />
      )}
      {viewBy === MONTH && (
        <DateTime
          disabled={viewBy === null}
          label="Month selected"
          selected={startDate}
          onChange={setDate}
          dateFormat="MM/yyyy"
          showMonthYearPicker
        />
      )}
      {DISABLED && <DateTime disabled label="Select Start Date" />}
    </>
  );
};

InputDate.propTypes = {
  viewBy: PropTypes.number,
  startDate: PropTypes.instanceOf(Date).isRequired,
  setStartDate: PropTypes.func.isRequired,
};

InputDate.defaultProps = {
  viewBy: PropTypes.oneOf([null, PropTypes.number]),
};

export default InputDate;
